module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.field.values), function(option) {
    return _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isValueHidden(option.label)),
        expression: "!isValueHidden(option.label)"
      }],
      staticClass: "mt-radio mt-radio-outline"
    }, [_vm._v("\n    " + _vm._s(option.label) + "\n    "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: _vm.required && !_vm.field.hide
        }),
        expression: "{required: required && !field.hide}"
      }],
      attrs: {
        "name": _vm.field.name,
        "data-vv-as": _vm.field.description.replace(/\./g, ''),
        "type": "radio",
        "id": option.name,
        "disabled": _vm.locked
      },
      domProps: {
        "value": option.label,
        "checked": _vm.value === option.label
      },
      on: {
        "change": function($event) {
          return _vm.$emit('input', option.label)
        }
      }
    }), _vm._v(" "), _c('span')])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aab62c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/RadioGroupRender.vue
// module id = 1634
// module chunks = 1